import './Forbidden.styles.css';

import { FC } from 'react';

const Forbidden: FC = () => (
  <div className="forbidden-wrapper">
    <h1>403</h1>
    <h2>Access Forbidden</h2>
  </div>
);

export default Forbidden;
